var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmartphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 27,
  viewBox: "0 0 20 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#2f2f2f;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -1)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18,
  height: 25,
  rx: 2,
  transform: "translate(5 2)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M14 22h0"
}))));
export default SvgSmartphone;